import { selectWarehouse, selectWarehouseStatus } from 'containers/Warehouses/warehousesSlice'
import { Redirect, useParams } from 'react-router-dom'
import React, { useEffect, useRef } from 'react'
import { useReduxSelector } from 'store'
import Loading from 'components/Loading'

/**
 * Ekrany zakonczenia/rezygnacji czytaja obiekt ze store przy pierwszym renderze
 * (stan poczatkowy formularza, contractId do wyceny). Przy wejsciu z linku
 * (np. mail "Podsumowanie zakonczenia wynajmu" -> /warehouses/{warehouseId}/termination)
 * lista obiektow moze nie byc jeszcze pobrana - wtedy czekamy na nia.
 * Pobranie listy wywoluje SubMenu (useWarehousesLoading(!contractId)).
 */
const WarehouseGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { id } = useParams<warehouse.PageParams>()
  const { contractId } = useReduxSelector(state => selectWarehouse(state, id))
  const status = useReduxSelector(selectWarehouseStatus)

  const fetchedAfterMount = useRef(false)
  useEffect(() => {
    if (status === 'pending') fetchedAfterMount.current = true
  }, [status])

  if (contractId) {
    return <React.Fragment key={contractId}>{children}</React.Fragment>
  }

  if (status === 'failed' || (status === 'succeed' && fetchedAfterMount.current)) {
    return <Redirect to='/warehouses' />
  }

  return <div className='menu__section menu__resignation'>
    <div className='resignation__main'>
      <Loading middleOfPage />
    </div>
  </div>
}

export default WarehouseGuard
